var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quote"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{name: "orderQuoteResources"}}},[_c('span',[_vm._v("1: 資料撮影")]),_c('Icon',{attrs:{"icon":"chevron-right"}})],1),_c('router-link',{attrs:{"to":{name: "orderQuoteInfoInput"}}},[_c('span',[_vm._v("2: 見積作成")]),_c('Icon',{attrs:{"icon":"chevron-right"}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }